"use strict";

(function() {

	/***************************************
		Main Events
	***************************************/

	var init = function() {
		contactForms();
	}


	var contactForms = function() {
		var elems = [].slice.call(document.querySelectorAll('.module-contactform'));
		if (!elems) return;

		elems.forEach(function(elem) {
			var form = elem.querySelector('form');

			form.addEventListener('contactform-sent', (e) => {
				if (!e.detail.success) return;

				window.dataLayer = window.dataLayer || [];
  				window.dataLayer.push({
    				event: 'Anfrage-erfolgreich'
  				});
			});
		});
	}



	init();
})();